/**
 * PALETTE-DERIVED SEGMENT COLOR flag (Gordon 2026-07-16,
 * SEGMENT-FILL-DESIGN-MODEL.md). Defined here (not re-exported from
 * featureFlags.js) so webpack always sees a real named export — a live
 * `export { X } from "...featureFlags"` was compiling as "module has no
 * exports" for every importer of this file.
 *
 * Same env.bool() convention as featureFlags.js: OFF unless
 * REACT_APP_SEGMENT_PALETTE_COLOR is "true" / "1". featureFlags.js also
 * exports this name from the same env var so both import paths stay in sync.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const SEGMENT_PALETTE_COLOR_ENABLED = truthy(
  process.env.REACT_APP_SEGMENT_PALETTE_COLOR
);
